const get = require('lodash/get')
const capitalize = require('lodash/capitalize')
const startsWith = require('lodash/startsWith')
const isNull = require('lodash/isNull')
const reduce = require('lodash/reduce')
const cloneDeep = require('lodash/cloneDeep')
const queryString = require('query-string')
const dateFns = require('date-fns')
const getTime = require('date-fns/get_time')
const differenceInSeconds = require('date-fns/difference_in_seconds')

function reduceCompose(a, b) {
  return function (...args) {
    return a(b(...args))
  }
}

function compose(funcs) {
  return reduce(funcs, reduceCompose)
}

const globalProperties = {
  has_adblock: false,
}

function updateGlobalProperties(key, value) {
  globalProperties[key] = value
}

function isAdBlockDetected() {
  if (!window) return false
  if (typeof window.blockAdBlock === 'undefined') {
    return updateGlobalProperties('has_adblock', true)
  }
  window.blockAdBlock.onDetected(() => {
    return updateGlobalProperties('has_adblock', true)
  })
  window.blockAdBlock.onNotDetected(() => {
    return updateGlobalProperties('has_adblock', false)
  })
}

function attachUTMParams(properties) {
  const parsedQueryParams = queryString.parse(get(window, 'location.search'))
  const utm_campaign = get(parsedQueryParams, 'utm_campaign', null)
  const utm_content = get(parsedQueryParams, 'utm_content', null)
  const utm_medium = get(parsedQueryParams, 'utm_medium', null)
  const utm_source = get(parsedQueryParams, 'utm_source', null)
  const utm_term = get(parsedQueryParams, 'utm_term', null)

  return {
    ...properties,
    utm_campaign,
    utm_content,
    utm_medium,
    utm_source,
    utm_term,
  }
}

function attachUserInformation(properties) {
  const accountUuid =
    get(window, 'BOOTSTRAP_DATA.authentication.user.uuid') || false
  const latestTriggerTime = localStorage.getItem('latest-trigger-time')
  const shopbackSessionIdKey = localStorage.getItem('shopback-session-time-key')
  const currentTimestamp = getTime(new Date())
  const latestTriggerTimeDiff = differenceInSeconds(
    new Date(),
    new Date(parseInt(latestTriggerTime, 10)),
  )
  const FIVE_MINUTES_IN_SECONDS = 60 * 5
  let shopback_session_id = null

  if (!latestTriggerTime || latestTriggerTimeDiff > FIVE_MINUTES_IN_SECONDS) {
    localStorage.setItem('latest-trigger-time', currentTimestamp)
    localStorage.setItem('shopback-session-time-key', currentTimestamp)
    shopback_session_id = `${accountUuid || 'guest'}_${currentTimestamp}`
  } else {
    shopback_session_id = `${accountUuid || 'guest'}_${shopbackSessionIdKey}`
  }

  return {
    ...properties,
    shopback_session_id,
    accountUuid,
  }
}

const specialScreenTypeMap = {
  campaign_v2: 'campaign',
}

function attachPageInformation(properties) {
  const domain = get(window, 'BOOTSTRAP_DATA.domain', '')
  const screen_type = get(window, 'BOOTSTRAP_DATA.router_class', '')
  const screen_id = get(window, 'BOOTSTRAP_DATA.screenId', '')
  const screen_name =
    get(window, 'BOOTSTRAP_DATA.screenName', false) ||
    get(window, 'location.pathname', '')
  const screen_url = get(window, 'location.href', '')
  const layout_id = get(window, 'BOOTSTRAP_DATA.layout_id', '')
  const layout_name = get(window, 'BOOTSTRAP_DATA.layout_name', '')
  const tracking_data = get(window, 'BOOTSTRAP_DATA.tracking_data', '')

  return {
    ...properties,
    ...tracking_data,
    domain,
    screen_type: get(specialScreenTypeMap, screen_type, screen_type),
    screen_id,
    screen_name: startsWith(screen_name, '/')
      ? capitalize(screen_name.replace(/[\/]/g, '').replace(/\-/g, ' '))
      : screen_name,
    screen_url,
    layout_id,
    layout_name,
  }
}

function attachTimestamp(properties) {
  return {
    ...properties,
    timestamp: dateFns.format(new Date(), 'X'),
  }
}

function attachDetectExtension(properties) {
  // SbExtensionAwesomeCheck is set by Shopback Buddy Extension
  const has_extension = !!get(window, 'SbExtensionAwesomeCheck', false)

  return {
    ...properties,
    has_extension,
  }
}

function attachDeviceInformation(properties) {
  return {
    ...properties,
    screen_resolution: `${window.screen.availWidth * window.devicePixelRatio} x ${window.screen.availHeight * window.devicePixelRatio}`,
    user_agent: window.navigator.userAgent,
  }
}

function attachReferrerInformation(properties) {
  const previous_screen_url = get(window, 'document.referrer', '')

  return {
    ...properties,
    previous_screen_url,
  }
}

const propertiesHandler = [
  attachUTMParams,
  attachUserInformation,
  attachDeviceInformation,
  attachPageInformation,
  attachTimestamp,
  attachDetectExtension,
  attachReferrerInformation,
]

const mainHandler = compose(propertiesHandler)

function getProperties() {
  const defaultProperties = cloneDeep(globalProperties)
  const properties = mainHandler(defaultProperties)
  return properties
}

isAdBlockDetected()

module.exports = getProperties
